module.exports = __webpack_public_path__ + "img/pro-zdIcon8.79f1ac96.png";